<div id="governing-body" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Governing Body</h2>
    <p class="inner-lead mt-3">
      The Governing Body of Shah Satnam Ji Girls' College, Sirsa is constituted as per the norms prescribed by Chaudhary
      Devi Lal University, Sirsa and the UGC. It oversees the academic, administrative and financial functioning of the
      institution to ensure quality and excellence in education.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">Official Document</h4>
    <p class="inner-lead">
      The official Governing Body letter issued by the management can be viewed and downloaded below:
    </p>

    <div class="pdf-block">
      <pdf-viewer src="/assets/pdf/admin/GOVERNING-BODY-LETTER.pdf" [render-text]="true" [original-size]="false"
        style="width:100%; height:680px; display:block;">
      </pdf-viewer>
    </div>

    <div class="mt-3">
      <a href="/assets/pdf/admin/GOVERNING-BODY-LETTER.pdf" target="_blank" class="pdf-download-btn">
        <i class="fa fa-download"></i> Download Governing Body Letter
      </a>
    </div>

  </div>
</div>